<script setup lang="ts">
interface CustomTrouserProps {
	trouserLengthHighlighted: boolean;
	waistHighlighted: boolean;
	thighHighlighted: boolean;
	kneeHighlighted: boolean;
	bottomHighlighted: boolean;
	hipHighlighted: boolean;
	customTrouser: {
		[key: string]: string;
	};
}

const props = defineProps<CustomTrouserProps>();

function set_rct_width(
	rct_pos_x: number,
	txt_pos_x: number,
	rect_id: string,
	text_id: string,
) {
	if (
		document != null &&
		process.client &&
		document.getElementById(text_id) !== null
	) {
		const txtelement = document.getElementById(text_id);
		const rct = document.getElementById(rect_id);
		let len = parseInt(txtelement.getComputedTextLength());
		if (len === 0 && rct) {
			rct.setAttributeNS(null, 'width', len);
			return len;
		} else {
			len = parseInt(len) + 25;
			rct.setAttributeNS(null, 'width', len);
			rct.setAttributeNS(null, 'x', rct_pos_x - len * (1 / 2));
			txtelement.setAttributeNS(null, 'x', txt_pos_x - len * (1 / 2));
			return len;
		}
	} else {
		return 50;
	}
}
</script>

<template>
	<div
		class="size-chart__custom-trouser-figure mb-xl size-figures bg-gray-50 gap-xs p-xs flex justify-center rounded"
	>
		<div class="lg:hidden component--trouserfigure-mobile block">
			<svg
				width="171"
				height="300"
				viewBox="0 0 171 300"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect width="171" height="300" rx="8" fill="#F6F6F6" />

				<!-- Hip -->
				<ellipse
					cx="87.1111"
					cy="72.0386"
					rx="52.8743"
					ry="4.32889"
					:stroke="hipHighlighted === true ? '#EA0000' : '#888888'"
					:stroke-width="hipHighlighted === true ? '1' : '0.5'"
					stroke-linecap="round"
					:stroke-dasharray="hipHighlighted === true ? 'none' : '3 3'"
				/>
				<!-- length -->
				<path
					d="M18 271.786L18 17"
					:stroke="trouserLengthHighlighted === true ? '#EA0000' : '#888888'"
					:stroke-width="trouserLengthHighlighted === true ? '1' : '0.5'"
					:stroke-dasharray="trouserLengthHighlighted === true ? 'none' : '3 3'"
				/>
				<!-- thigh -->
				<ellipse
					cx="114.012"
					cy="120.275"
					rx="25.3549"
					ry="1.85524"
					:stroke="thighHighlighted === true ? '#EA0000' : '#888888'"
					:stroke-width="thighHighlighted === true ? '1' : '0.5'"
					stroke-linecap="round"
					:stroke-dasharray="thighHighlighted === true ? 'none' : '3 3'"
				/>
				<!-- knee -->
				<ellipse
					cx="114.012"
					cy="171.603"
					rx="21.6445"
					ry="1.85524"
					:stroke="kneeHighlighted === true ? '#EA0000' : '#888888'"
					:stroke-width="kneeHighlighted === true ? '1' : '0.5'"
					stroke-linecap="round"
					:stroke-dasharray="kneeHighlighted === true ? 'none' : '3 3'"
				/>
				<!-- bottom -->
				<ellipse
					cx="114.012"
					cy="270.549"
					rx="17.3156"
					ry="1.23683"
					:stroke="bottomHighlighted === true ? '#EA0000' : '#888888'"
					:stroke-width="bottomHighlighted === true ? '1' : '0.5'"
					stroke-linecap="round"
					:stroke-dasharray="bottomHighlighted === true ? 'none' : '3 3'"
				/>
				<!-- waist -->
				<path
					d="M49.6973 17.3301L124.645 17"
					:stroke="waistHighlighted === true ? '#EA0000' : '#888888'"
					:stroke-width="waistHighlighted === true ? '1' : '0.5'"
					:stroke-dasharray="waistHighlighted === true ? 'none' : '3 3'"
				/>
				<!-- trouser -->
				<path
					d="M49.392 21.9472H124.529M49.392 21.9472C52.7933 22.5656 73.5101 26.5853 87.1152 26.5853C102.262 26.5853 116.284 23.5963 124.529 21.9472M49.392 21.9472C48.8575 23.1449 48.2723 24.4935 47.6511 25.9669M124.529 21.9472C125.064 23.1449 125.649 24.4935 126.27 25.9669M47.6511 25.9669C41.8045 39.8354 32.7805 64.7538 33.0041 78.8412C33.2514 94.4252 39.0851 213.965 41.9711 271.786C47.9491 273.126 63.43 275.002 77.5298 271.786L87.1152 78.8412L96.3914 271.786C110.491 275.002 125.972 273.126 131.95 271.786C134.836 213.965 140.67 94.4252 140.917 78.8412C141.141 64.7538 132.117 39.8354 126.27 25.9669M47.6511 25.9669C52.8695 27.7191 68.8102 31.2234 87.1152 31.2234C105.42 31.2234 120.536 27.7191 126.27 25.9669"
					stroke="#222222"
					stroke-linejoin="round"
				/>
			</svg>
		</div>

		<div class="lg:block component--trouserfigure-desktop hidden">
			<svg
				width="310"
				height="508"
				viewBox="0 0 310 508"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect width="309.458" height="508" rx="8" fill="#F6F6F6" />
				<!-- Length -->

				<g v-if="trouserLengthHighlighted === true">
					<path d="M41 459L41 47" stroke="#EA0000" stroke-width="0.75" />
					<rect
						id="rct_trouserlength"
						x="15"
						y="200"
						:width="
							set_rct_width(40, 53, 'rct_trouserlength', 'txt_trouserlength')
						"
						height="26"
						rx="13"
						fill="#EA0000"
					/>
					<text
						id="txt_trouserlength"
						x="31"
						y="218"
						fill="white"
						class="text-base font-semibold"
					>
						{{ props.customTrouser['Trouser Length'] }}
					</text>
				</g>

				<path
					v-else
					d="M41 459L41 47"
					stroke="#888888"
					stroke-width="0.5"
					stroke-dasharray="3 3"
				/>

				<g v-if="hipHighlighted === true">
					<ellipse
						cx="155"
						cy="136"
						rx="85.5"
						ry="7"
						stroke="#EA0000"
						stroke-width="0.5"
						stroke-linecap="round"
					/>
					<rect
						id="rct_trouserHip"
						x="130"
						y="120"
						:width="set_rct_width(155, 168, 'rct_trouserHip', 'txt_trouserHip')"
						height="26"
						rx="13"
						fill="#EA0000"
					/>
					<text
						id="txt_trouserHip"
						x="146"
						y="138"
						fill="white"
						class="text-base font-semibold"
					>
						{{ props.customTrouser['Trouser Hip'] }}
					</text>
				</g>

				<g v-else>
					<ellipse
						cx="154.5"
						cy="136"
						rx="85.5"
						ry="7"
						stroke="#888888"
						stroke-width="0.5"
						stroke-linecap="round"
						stroke-dasharray="3 3"
					/>
				</g>

				<g v-if="waistHighlighted === true">
					<path
						d="M94 47.5339L215.194 47"
						stroke="#EA0000"
						stroke-width="0.5"
					/>
					<rect
						id="rct_trouserWaist"
						x="130"
						y="28"
						:width="
							set_rct_width(155, 168, 'rct_trouserWaist', 'txt_trouserWaist')
						"
						height="26"
						rx="13"
						fill="#EA0000"
					/>
					<text
						id="txt_trouserWaist"
						x="146"
						y="46"
						fill="white"
						class="text-base font-semibold"
					>
						{{ props.customTrouser['Trouser Waist'] }}
					</text>
				</g>
				<g v-else>
					<path
						d="M94 47.5339L215.194 47"
						stroke="#888888"
						stroke-width="0.5"
						stroke-dasharray="3 3"
					/>
				</g>

				<g v-if="thighHighlighted === true">
					<ellipse
						cx="198"
						cy="214"
						rx="41"
						ry="3"
						stroke="#EA0000"
						stroke-width="0.5"
						stroke-linecap="round"
					/>
					<rect
						id="rct_trouserThigh"
						x="172"
						y="190"
						:width="
							set_rct_width(198, 213, 'rct_trouserThigh', 'txt_trouserThigh')
						"
						height="26"
						rx="13"
						fill="#EA0000"
					/>
					<text
						id="txt_trouserThigh"
						x="188"
						y="208"
						fill="white"
						class="text-base font-semibold"
					>
						{{ props.customTrouser['Trouser Thigh'] }}
					</text>
				</g>
				<g v-else>
					<ellipse
						cx="198"
						cy="214"
						rx="41"
						ry="3"
						stroke="#888888"
						stroke-width="0.5"
						stroke-linecap="round"
						stroke-dasharray="3 3"
					/>
				</g>

				<!-- knee -->
				<g v-if="kneeHighlighted === true">
					<ellipse
						cx="198"
						cy="297"
						rx="35"
						ry="3"
						stroke="#EA0000"
						stroke-width="0.5"
						stroke-linecap="round"
					/>
					<rect
						id="rct_trouserKnee"
						x="174"
						y="273"
						:width="
							set_rct_width(198, 210, 'rct_trouserKnee', 'txt_trouserKnee')
						"
						height="26"
						rx="13"
						fill="#EA0000"
					/>
					<text
						id="txt_trouserKnee"
						x="190"
						y="292"
						fill="white"
						class="text-base font-semibold"
					>
						{{ props.customTrouser['Trouser Knee'] }}
					</text>
				</g>
				<g v-else>
					<ellipse
						cx="198"
						cy="297"
						rx="35"
						ry="3"
						stroke="#888888"
						stroke-width="0.5"
						stroke-linecap="round"
						stroke-dasharray="3 3"
					/>
				</g>
				<g v-if="bottomHighlighted === true">
					<ellipse
						cx="198"
						cy="457"
						rx="28"
						ry="2"
						stroke="#EA0000"
						stroke-width="0.5"
						stroke-linecap="round"
					/>
					<rect
						id="rct_trouserBottom"
						x="173"
						y="465"
						:width="
							set_rct_width(198, 210, 'rct_trouserBottom', 'txt_trouserBottom')
						"
						height="26"
						rx="13"
						fill="#EA0000"
					/>
					<text
						id="txt_trouserBottom"
						x="189"
						y="484"
						fill="white"
						class="text-base font-semibold"
					>
						{{ props.customTrouser['Trouser Bottom'] }}
					</text>
				</g>
				<g v-else>
					<ellipse
						cx="198"
						cy="457"
						rx="28"
						ry="2"
						stroke="#888888"
						stroke-width="0.5"
						stroke-linecap="round"
						stroke-dasharray="3 3"
					/>
				</g>

				<!-- baki pant -->
				<path
					d="M93.5066 54.9999H215.007M93.5066 54.9999C99.0066 55.9999 132.507 62.4999 154.507 62.4999C179 62.4999 201.673 57.6666 215.007 54.9999M93.5066 54.9999C92.6423 56.9367 91.6959 59.1175 90.6915 61.4999M215.007 54.9999C215.871 56.9367 216.817 59.1175 217.822 61.4999M90.6915 61.4999C81.2373 83.9258 66.645 124.22 67.0066 147C67.4066 172.2 76.8399 365.5 81.5066 459C91.1733 461.167 116.207 464.2 139.007 459L154.507 147L169.507 459C192.307 464.2 217.34 461.167 227.007 459C231.673 365.5 241.107 172.2 241.507 147C241.868 124.22 227.276 83.9258 217.822 61.4999M90.6915 61.4999C99.1299 64.3333 124.907 69.9999 154.507 69.9999C184.107 69.9999 208.55 64.3333 217.822 61.4999"
					stroke="#222222"
					stroke-linejoin="round"
				/>
			</svg>
		</div>
	</div>
</template>
